import type { InAppNotification } from '@/types/inAppNotification';

const MAX_ENTRIES = 50;

type BufferedNotification = {
  sequence: number;
  notification: InAppNotification;
};

let entries: BufferedNotification[] = [];
let sequence = 0;

/**
 * Remembers notifications that arrive over the socket, so a backfill that was
 * already in flight cannot discard them.
 *
 * The backfill response is authoritative, but it is computed *before* it is
 * received: a notification broadcast in between is absent from the response and
 * would be wiped out when it replaces the cache entry. Losing a notification
 * that way is silent, and closing that window is the whole point of the backfill.
 */
export const liveNotificationBuffer = {
  mark: () => sequence,

  record: (notification: InAppNotification) => {
    sequence += 1;
    entries.push({ sequence, notification });

    if (entries.length > MAX_ENTRIES) {
      entries = entries.slice(-MAX_ENTRIES);
    }
  },

  since: (mark: number) => entries
    .filter((entry) => entry.sequence > mark)
    .map((entry) => entry.notification),

  reset: () => {
    entries = [];
    sequence = 0;
  },
};
